import { ViewerInfo, ViewerParams } from '@/modules/viewerModule/services/viewer.dto'

class ViewerService {
    private openedViewers: ViewerInfo[] = []

    public closeViewersOfDifferentCase(caseId: string):void {
        const oldOpened = this.openedViewers
        this.openedViewers = this.openedViewers.filter(viewerInfo => viewerInfo.caseId === caseId)
        oldOpened.filter(viewerInfo => viewerInfo.caseId !== caseId).forEach(viewerInfo => viewerInfo.window.close())
    }

    public closeAllViewers():void {
        this.openedViewers.forEach(viewerWindow => viewerWindow.window.close())
        this.openedViewers = []
    }

    public openViewer(viewerParams: ViewerParams): void {
        const query = {
            laboratoryId: `${viewerParams.laboratoryId}`,
            caseId: `${viewerParams.caseId}`,
            sampleId: `${viewerParams.sampleId}`,
            portionId: viewerParams.portionId ? `${viewerParams.portionId}` : undefined,
            subportionId: viewerParams.subportionId ? `${viewerParams.subportionId}` : undefined,
            attachmentId: `${viewerParams.attachmentId}`,
            viewerType: `${viewerParams.viewerType}`,
            label: viewerParams.label ? `${viewerParams.label}` : undefined
        }
        const viewerModuleRoute = viewerParams.router.resolve({
            name: 'viewerModule',
            query
        })
        const viewerWindow = window.open(viewerModuleRoute.href, '_blank')
        if (viewerWindow) {
            this.openedViewers.push({
                window: viewerWindow,
                laboratoryId: query.laboratoryId,
                caseId: query.caseId,
                sampleId: query.sampleId,
                portionId: query.portionId,
                subportionId: query.subportionId,
                attachmentId: query.attachmentId,
                viewerType: query.viewerType,
                label: query.label
            })
        }
    }
}

export const viewerService = new ViewerService()
